var _excluded = ["children", "label", "ariaLabel", "id", "on", "debug", "hasArrow", "position"],
  _excluded2 = ["defaultPosition", "label", "variant", "className", "style", "position", "on", "debug"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useRef, useState, useCallback, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTransition, animated } from "@react-spring/web";
import { toPx, isIcon } from "../../helpers";
import { useId } from "../../helpers/hooks";
function TooltipPopup(_ref) {
  var id = _ref.id,
    label = _ref.label,
    ariaLabel = _ref.ariaLabel,
    style = _ref.style,
    className = _ref.className,
    position = _ref.position,
    triggerRect = _ref.triggerRect;
  var tooltipRef = useRef(null);
  useLayoutEffect(function () {
    var el = tooltipRef.current;
    if (!el || !triggerRect || !position) return;
    var tooltipRect = el.getBoundingClientRect();
    var pos = position(triggerRect, tooltipRect);
    if (pos) {
      if (pos.left !== undefined) el.style.left = toPx(pos.left);
      if (pos.top !== undefined) el.style.top = toPx(pos.top);
    }
  });
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(animated.div, {
    ref: tooltipRef,
    role: "tooltip",
    id: "tooltip--".concat(id),
    "data-reach-tooltip": "",
    className: className,
    style: _objectSpread({
      position: "absolute"
    }, style),
    "aria-label": ariaLabel
  }, label), document.body);
}
function BaseTooltip(_ref2) {
  var _children$props7, _children$props8, _children$props9, _children$props0, _children$props1, _children$props10;
  var children = _ref2.children,
    label = _ref2.label,
    ariaLabel = _ref2.ariaLabel,
    id = _ref2.id,
    _ref2$on = _ref2.on,
    on = _ref2$on === void 0 ? "any" : _ref2$on,
    _ref2$debug = _ref2.debug,
    debug = _ref2$debug === void 0 ? false : _ref2$debug,
    _ref2$hasArrow = _ref2.hasArrow,
    hasArrow = _ref2$hasArrow === void 0 ? true : _ref2$hasArrow,
    position = _ref2.position,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useState = useState(Boolean(debug)),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var triggerRef = useRef(null);
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    triggerRect = _useState4[0],
    setTriggerRect = _useState4[1];
  var measureTrigger = useCallback(function () {
    if (triggerRef.current) {
      setTriggerRect(triggerRef.current.getBoundingClientRect());
    }
  }, []);
  useEffect(function () {
    if (!isVisible) {
      setTriggerRect(null);
      return;
    }
    measureTrigger();
    window.addEventListener("scroll", measureTrigger, true);
    window.addEventListener("resize", measureTrigger);
    return function () {
      window.removeEventListener("scroll", measureTrigger, true);
      window.removeEventListener("resize", measureTrigger);
    };
  }, [isVisible, measureTrigger]);
  var show = useCallback(function () {
    return setIsVisible(true);
  }, []);
  var hide = useCallback(function () {
    if (!debug) setIsVisible(false);
  }, [debug]);
  var prevLabelRef = useRef("");
  useEffect(function () {
    prevLabelRef.current = label;
  }, [label, isVisible]);
  var triggerProps = {
    "aria-describedby": isVisible ? "tooltip--".concat(id) : undefined,
    ref: triggerRef,
    onMouseEnter: function onMouseEnter(e) {
      var _children$props$onMou, _children$props;
      show();
      (_children$props$onMou = (_children$props = children.props).onMouseEnter) === null || _children$props$onMou === void 0 || _children$props$onMou.call(_children$props, e);
    },
    onMouseLeave: function onMouseLeave(e) {
      var _children$props$onMou2, _children$props2;
      hide();
      (_children$props$onMou2 = (_children$props2 = children.props).onMouseLeave) === null || _children$props$onMou2 === void 0 || _children$props$onMou2.call(_children$props2, e);
    },
    onMouseMove: function onMouseMove(e) {
      var _children$props$onMou3, _children$props3;
      if (!isVisible) show();
      (_children$props$onMou3 = (_children$props3 = children.props).onMouseMove) === null || _children$props$onMou3 === void 0 || _children$props$onMou3.call(_children$props3, e);
    },
    onFocus: function onFocus(e) {
      var _children$props$onFoc, _children$props4;
      show();
      (_children$props$onFoc = (_children$props4 = children.props).onFocus) === null || _children$props$onFoc === void 0 || _children$props$onFoc.call(_children$props4, e);
    },
    onBlur: function onBlur(e) {
      hide();
      if (children.props.onBlur) {
        children.props.onBlur(e);
      }
    },
    onMouseDown: function onMouseDown(e) {
      var _children$props$onMou4, _children$props5;
      hide();
      (_children$props$onMou4 = (_children$props5 = children.props).onMouseDown) === null || _children$props$onMou4 === void 0 || _children$props$onMou4.call(_children$props5, e);
    },
    onKeyDown: function onKeyDown(e) {
      var _children$props$onKey, _children$props6;
      if (e.key === "Escape") hide();
      (_children$props$onKey = (_children$props6 = children.props).onKeyDown) === null || _children$props$onKey === void 0 || _children$props$onKey.call(_children$props6, e);
    }
  };
  switch (on) {
    case "hover":
      triggerProps.onFocus = (_children$props7 = children.props) === null || _children$props7 === void 0 ? void 0 : _children$props7.onFocus;
      triggerProps.onBlur = (_children$props8 = children.props) === null || _children$props8 === void 0 ? void 0 : _children$props8.onBlur;
      triggerProps.onMouseDown = (_children$props9 = children.props) === null || _children$props9 === void 0 ? void 0 : _children$props9.onMouseDown;
      break;
    case "click":
      triggerProps.onMouseEnter = undefined;
      triggerProps.onMouseLeave = undefined;
      triggerProps.onMouseMove = undefined;
      triggerProps.onPointerEnter = undefined;
      triggerProps.onPointerLeave = undefined;
      triggerProps.onPointerMove = undefined;
      if ((_children$props0 = children.props) !== null && _children$props0 !== void 0 && _children$props0.onMouseEnter) {
        triggerProps.onMouseEnter = children.props.onMouseEnter;
      }
      if ((_children$props1 = children.props) !== null && _children$props1 !== void 0 && _children$props1.onMouseLeave) {
        triggerProps.onMouseLeave = children.props.onMouseLeave;
      }
      if ((_children$props10 = children.props) !== null && _children$props10 !== void 0 && _children$props10.onMouseMove) {
        triggerProps.onMouseMove = children.props.onMouseMove;
      }
      break;
    default:
      break;
  }
  var tooltipData = triggerRect ? {
    id: id,
    triggerRect: triggerRect
  } : null;
  var transitions = useTransition([isVisible ? tooltipData : null], {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      mass: 1,
      tension: 500,
      friction: 40
    },
    keys: function keys(item) {
      return (item === null || item === void 0 ? void 0 : item.id) || "tooltip";
    }
  });
  var displayLabel = label || prevLabelRef.current;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(React.Children.only(children), triggerProps), transitions(function (style, item) {
    return item && /*#__PURE__*/React.createElement(TooltipPopup, {
      id: item.id,
      triggerRect: item.triggerRect,
      ariaLabel: ariaLabel,
      position: position,
      className: rest.className,
      style: style,
      label: displayLabel ? /*#__PURE__*/React.createElement(React.Fragment, null, displayLabel, /*#__PURE__*/React.createElement("div", {
        className: "arrow",
        style: {
          display: hasArrow ? null : "none"
        }
      })) : ""
    });
  }));
}
BaseTooltip.propTypes = {
  on: PropTypes.oneOf(["click", "hover", "any"]),
  children: PropTypes.node.isRequired,
  label: PropTypes.node,
  ariaLabel: PropTypes.string,
  debug: PropTypes.bool,
  hasArrow: PropTypes.bool
};
var shouldAppearAbove = function shouldAppearAbove(collisions, defaultPosition) {
  return defaultPosition === "bottom" && !collisions.top || collisions.bottom;
};
var Tooltip = function Tooltip(_ref3) {
  var _ref3$defaultPosition = _ref3.defaultPosition,
    defaultPosition = _ref3$defaultPosition === void 0 ? "bottom" : _ref3$defaultPosition,
    label = _ref3.label,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? "dark" : _ref3$variant,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? "" : _ref3$className,
    _ref3$style = _ref3.style,
    style = _ref3$style === void 0 ? {} : _ref3$style,
    _ref3$position = _ref3.position,
    position = _ref3$position === void 0 ? function (styles) {
      return styles;
    } : _ref3$position,
    _ref3$on = _ref3.on,
    on = _ref3$on === void 0 ? "any" : _ref3$on,
    _ref3$debug = _ref3.debug,
    debug = _ref3$debug === void 0 ? false : _ref3$debug,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var id = "tui-tooltip-".concat(useId());
  return /*#__PURE__*/React.createElement(BaseTooltip, _extends({}, props, {
    label: label,
    variant: variant,
    on: on,
    debug: debug,
    id: id,
    className: classNames(variant, _defineProperty({}, className, className)),
    style: label ? style : {
      display: "none"
    },
    hasArrow: defaultPosition !== "right",
    position: function position(triggerRect, tooltipRect) {
      var offset = 10;
      var offsetWidth = 2;
      var tooltipElement = document.querySelector("#tooltip--".concat(id));
      if (!tooltipElement || !tooltipRect || !triggerRect) return {};
      var tooltipArrowElement = tooltipElement.querySelector(".arrow");
      if (!tooltipArrowElement) return {};
      var triggerCenter = triggerRect.left + triggerRect.width / 2;
      var left = triggerCenter - tooltipRect.width / 2;
      var maxLeft = document.documentElement.clientWidth - tooltipRect.width - offsetWidth;

      // reset classes
      tooltipElement.classList.remove("top", "bottom", "right", "left");
      tooltipArrowElement.classList.remove("above", "right");
      var collisions = {
        top: triggerRect.top - tooltipRect.height < 0,
        bottom: window.innerHeight < (defaultPosition === "right" ? triggerRect.top : triggerRect.bottom) + tooltipRect.height,
        right: document.documentElement.clientWidth < triggerCenter + tooltipRect.width / 2 + offsetWidth,
        left: triggerCenter - tooltipRect.width / 2 - offsetWidth < 0
      };
      if (defaultPosition === "right") {
        collisions.right = document.documentElement.clientWidth < triggerRect.right + tooltipRect.width + offsetWidth;
      }
      var horizontalPosition = function () {
        if (collisions.right) return "left";
        if (collisions.left) return "right";
        return "center";
      }();
      var isAbove = shouldAppearAbove(collisions, defaultPosition);
      tooltipElement.classList.add(isAbove ? "top" : "bottom");
      var tooltipLeft, top;
      if (defaultPosition !== "right") {
        var arrowLeft, arrowRight;
        switch (horizontalPosition) {
          case "left":
            tooltipLeft = triggerCenter - tooltipRect.width;
            arrowLeft = "unset";
            arrowRight = 0;
            tooltipElement.classList.add("left");
            break;
          case "right":
          default:
            {
              var clampedLeft = Math.min(Math.max(2, left), maxLeft);
              tooltipLeft = clampedLeft + window.scrollX;
              arrowLeft = triggerCenter - tooltipArrowElement.getBoundingClientRect().width / 2 - clampedLeft;
              arrowRight = "unset";
            }
        }
        tooltipArrowElement.style.left = toPx(arrowLeft);
        tooltipArrowElement.style.right = toPx(arrowRight);
        top = isAbove ? triggerRect.top - offset - tooltipRect.height + window.scrollY : triggerRect.bottom + offset + window.scrollY;
      } else {
        tooltipLeft = triggerRect.left + triggerRect.width + offset;
        var triggerVerticalCenter = triggerRect.top + triggerRect.height / 2;
        var rowHeight = 36;
        top = triggerVerticalCenter - rowHeight / 2;
        if (isAbove) {
          top = triggerRect.bottom - tooltipRect.height;
        }
        if (collisions.right) {
          tooltipLeft = triggerRect.left - tooltipRect.width - offset;
        }
      }
      return {
        left: tooltipLeft,
        top: top
      };
    }
  }), isIcon(props.children) ? /*#__PURE__*/React.createElement("span", null, props.children) : props.children);
};
Tooltip.propTypes = {
  label: PropTypes.node,
  variant: PropTypes.oneOf(["light", "dark"]),
  className: PropTypes.string,
  children: PropTypes.element.isRequired,
  style: PropTypes.object,
  position: PropTypes.func,
  on: PropTypes.oneOf(["click", "hover", "any"]),
  debug: PropTypes.bool,
  defaultPosition: PropTypes.oneOf(["bottom", "top", "right"])
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map